import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { IToast } from '../../../core/models/toast.model';

/** Pila de toasts: abajo a la derecha a 24 px del borde (celular: ancho completo − 16 px). Máx. 3, el más nuevo abajo. */
@Component({
  selector: 'app-toast-stack',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { '[style.--cr-toast-offset]': "toasts.offset() + 'px'" },
  template: `
    @for (t of toasts.toasts(); track t.id) {
      <div class="toast" role="status" aria-live="polite" (mouseenter)="toasts.pause(t.id)" (mouseleave)="toasts.resume(t.id)">
        <span class="ic" [class]="'ic ic--' + t.tone"><cr-icon [name]="icon(t)" [size]="20" /></span>
        <span class="msg">{{ t.message }}</span>
        @if (t.action) { <button type="button" class="act" (click)="run(t)">{{ t.action.label }}</button> }
      </div>
    }
  `,
  styles: [`
    :host{position:fixed;right:var(--cr-toast-gap);bottom:calc(var(--cr-toast-gap) + var(--cr-toast-offset, 0px));z-index:var(--cr-z-toast);display:flex;flex-direction:column;gap:12px;align-items:flex-end;pointer-events:none}
    .toast{pointer-events:auto;display:flex;align-items:center;gap:12px;width:392px;max-width:calc(100vw - 32px);min-height:60px;padding:10px 20px 10px 10px;
      border-radius:999px;background:var(--cr-bg-inverse);color:var(--cr-text-inverse);box-shadow:var(--cr-elevation-3);
      animation:in var(--cr-motion-slow) var(--cr-ease-emphasized)}
    .ic{width:36px;height:36px;border-radius:50%;display:grid;place-items:center;color:#fff;flex:none}
    .ic--success{background:var(--cr-success)} .ic--info{background:var(--cr-brand-teal)} .ic--error{background:var(--cr-danger)}
    .msg{flex:1;font:600 15px/20px var(--cr-font-body);white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
    .act{border:0;background:none;color:var(--cr-brand-gold);font:600 14px/18px var(--cr-font-body);padding:4px;cursor:pointer}
    @keyframes in{from{opacity:0;transform:translateY(16px) scale(.98)}to{opacity:1;transform:none}}
    @media (max-width:640px){
      :host{left:8px;right:8px;bottom:calc(8px + env(safe-area-inset-bottom) + var(--cr-toast-offset, 0px));align-items:stretch}
      .toast{width:auto;max-width:none}
    }
  `],
})
export class ToastStackComponent {
  readonly toasts = inject(ToastService);

  icon(t: IToast): string {
    return t.tone === 'success' ? 'check' : t.tone === 'error' ? 'alert' : 'info';
  }

  run(t: IToast): void {
    t.action?.handler();
    this.toasts.dismiss(t.id);
  }
}
